import type { Status } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/adverts';
import type { CreativesState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/creatives';

export const getStatus = (state: CreativesState): Status => state.status;
